export const POSTAL_CODE_PREFIXES = [
    {
        "name": "A Coruña",
        "postal_code_prefix": "15"
    },
    {
        "name": "Álava",
        "postal_code_prefix": "01"
    },
    {
        "name": "Albacete",
        "postal_code_prefix": "02"
    },
    {
        "name": "Alicante",
        "postal_code_prefix": "03"
    },
    {
        "name": "Almería",
        "postal_code_prefix": "04"
    },
    {
        "name": "Asturias",
        "postal_code_prefix": "33"
    },
    {
        "name": "Ávila",
        "postal_code_prefix": "05"
    },
    {
        "name": "Badajoz",
        "postal_code_prefix": "06"
    },
    {
        "name": "Baleares",
        "postal_code_prefix": "07"
    },
    {
        "name": "Barcelona",
        "postal_code_prefix": "08"
    },
    {
        "name": "Burgos",
        "postal_code_prefix": "09"
    },
    {
        "name": "Cáceres",
        "postal_code_prefix": "10"
    },
    {
        "name": "Cádiz",
        "postal_code_prefix": "11"
    },
    {
        "name": "Cantabria",
        "postal_code_prefix": "39"
    },
    {
        "name": "Castellón",
        "postal_code_prefix": "12"
    },
    {
        "name": "Ciudad Real",
        "postal_code_prefix": "13"
    },
    {
        "name": "Córdoba",
        "postal_code_prefix": "14"
    },
    {
        "name": "Cuenca",
        "postal_code_prefix": "16"
    },
    {
        "name": "Girona",
        "postal_code_prefix": "17"
    },
    {
        "name": "Granada",
        "postal_code_prefix": "18"
    },
    {
        "name": "Guadalajara",
        "postal_code_prefix": "19"
    },
    {
        "name": "Gipuzkoa",
        "postal_code_prefix": "20"
    },
    {
        "name": "Huelva",
        "postal_code_prefix": "21"
    },
    {
        "name": "Huesca",
        "postal_code_prefix": "22"
    },
    {
        "name": "Jaén",
        "postal_code_prefix": "23"
    },
    {
        "name": "La Rioja",
        "postal_code_prefix": "26"
    },
    {
        "name": "Las Palmas",
        "postal_code_prefix": "35"
    },
    {
        "name": "León",
        "postal_code_prefix": "24"
    },
    {
        "name": "Lérida",
        "postal_code_prefix": "25"
    },
    {
        "name": "Lugo",
        "postal_code_prefix": "27"
    },
    {
        "name": "Madrid",
        "postal_code_prefix": "28"
    },
    {
        "name": "Málaga",
        "postal_code_prefix": "29"
    },
    {
        "name": "Murcia",
        "postal_code_prefix": "30"
    },
    {
        "name": "Navarra",
        "postal_code_prefix": "31"
    },
    {
        "name": "Ourense",
        "postal_code_prefix": "32"
    },
    {
        "name": "Palencia",
        "postal_code_prefix": "34"
    },
    {
        "name": "Pontevedra",
        "postal_code_prefix": "36"
    },
    {
        "name": "Salamanca",
        "postal_code_prefix": "37"
    },
    {
        "name": "Segovia",
        "postal_code_prefix": "40"
    },
    {
        "name": "Sevilla",
        "postal_code_prefix": "41"
    },
    {
        "name": "Soria",
        "postal_code_prefix": "42"
    },
    {
        "name": "Tarragona",
        "postal_code_prefix": "43"
    },
    {
        "name": "Santa Cruz de Tenerife",
        "postal_code_prefix": "38"
    },
    {
        "name": "Teruel",
        "postal_code_prefix": "44"
    },
    {
        "name": "Toledo",
        "postal_code_prefix": "45"
    },
    {
        "name": "Valencia",
        "postal_code_prefix": "46"
    },
    {
        "name": "Valladolid",
        "postal_code_prefix": "47"
    },
    {
        "name": "Vizcaya",
        "postal_code_prefix": "48"
    },
    {
        "name": "Zamora",
        "postal_code_prefix": "49"
    },
    {
        "name": "Zaragoza",
        "postal_code_prefix": "50"
    }
];

export const POSTAL_CODE_REGEX = /^(0[1-9]|[1-4]\d|5[0-2])\d{3}$/;